import React from "react";
import ReactExport from "react-export-excel";
import { FileExcelOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function ExportacaoExcell({ dados, ...props }) {
  return (
    <ExcelFile
      element={
        <Tooltip title="Exportar para Excell">
          <FileExcelOutlined className="icon-styled" style={{ fontSize: 30 }} />
        </Tooltip>
      }
    >
      <ExcelSheet data={dados} name="Analise">
        <ExcelColumn label="CÓDIGO" value="codigo" />
        <ExcelColumn label="CNPJ" value="cnpj" />
        <ExcelColumn label="NOME" value="nome" />
        <ExcelColumn label="RAZAO SOCIAL" value="razaoSocial" />
        <ExcelColumn label="FANTASIA" value="fantasia" />
        <ExcelColumn label="EMAIL" value="email" />

        <ExcelColumn label="SEGMENTO" value="segmento" />
        <ExcelColumn label="FATURAMENTO" value="fxFaturamento" />
        <ExcelColumn label="PORTE PDV" value="portePdv" />
        <ExcelColumn label="MODELO NEGÓCIO" value="modeloNegocio" />
        <ExcelColumn label="TIPO EMPRESA" value="tipoEmpresa" />
        <ExcelColumn label="PERFIL" value="perfil" />
        <ExcelColumn label="RG COMERCIAL" value="rgComer" />
        <ExcelColumn label="RG GEOGRAFICA" value="rgGeo" />
        <ExcelColumn label="REDE" value="rede" />
        <ExcelColumn label="FEDERAÇÃO" value="federacao" />

        <ExcelColumn label="ESTADO" value="estado" />
        <ExcelColumn label="CIDADE" value="cidade" />

      </ExcelSheet>
    </ExcelFile>
  );
}

export default ExportacaoExcell;
